import React from 'react';
import fffLogo from './fff-logo.svg';
import styles from './Header.module.css';
import ProgressNavBar from '../ProgressNodeBar/ProgressNavBar';

function Header() {
  return (
    <>
      <div className={styles.header}>
        <img src={fffLogo} alt="logo" className={styles.fffLogo} data-testid="fff-logo" />
        <div className={styles.gradient} />
        <ProgressNavBar />
        <div className={styles.gradient} />
      </div>
    </>
  );
}

export default Header;
